import { Dropdown, Button } from "antd";
import { useTabs } from "~/contexts/TabContext";
import { useNavigate, useLocation } from "@remix-run/react";
import { useEffect, useRef } from "react";

export default function TabBar() {
  const { tabs, activeTab, closeTab, closeAllTabs, closeOtherTabs, setActiveTab } = useTabs();
  const navigate = useNavigate();
  const location = useLocation();
  const tabsRef = useRef(tabs);
  tabsRef.current = tabs;
  const activeTabRef = useRef(activeTab);
  activeTabRef.current = activeTab;

  useEffect(() => {
    if (tabs.length > 0 && tabs.some(t => t.path === location.pathname)) {
      if (activeTab !== location.pathname) {
        setActiveTab(location.pathname);
      }
    }
  }, [location.pathname]);

  const handleClose = (path: string) => {
    const currentTabs = tabsRef.current;
    const currentActiveTab = activeTabRef.current;
    closeTab(path);
    if (path === currentActiveTab) {
      if (currentTabs.length > 1) {
        const remaining = currentTabs.filter(t => t.path !== path);
        const idx = currentTabs.findIndex(t => t.path === path);
        const newIdx = Math.min(idx, remaining.length - 1);
        navigate(remaining[newIdx].path);
      } else {
        navigate("/pages/blank", { replace: true });
      }
    }
  };

  if (tabs.length === 0) return null;

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      background: "#fff",
      borderBottom: "1px solid #e8e8e8",
      padding: "0px 8px",
      height: 40,
    }}>
      {tabs.map(tab => {
        const isActive = tab.path === activeTab;
        return (
          <div
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "6px 12px",
              cursor: "pointer",
              borderBottom: isActive ? "2px solid #1890ff" : "2px solid transparent",
              color: isActive ? "#1890ff" : "rgba(0,0,0,0.65)",
              fontSize: 13,
              gap: 6,
              userSelect: "none",
              whiteSpace: "nowrap",
            }}
          >
            <span>{tab.label}</span>
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleClose(tab.path);
              }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 16,
                height: 16,
                borderRadius: "50%",
                fontSize: 12,
                cursor: "pointer",
                color: "rgba(0,0,0,0.35)",
                lineHeight: "16px",
              }}
            >
              ×
            </span>
          </div>
        );
      })}
      <div style={{ marginLeft: "auto" }}>
        {tabs.length > 0 && (
          <Dropdown menu={{
            items: [
              { key: "closeOthers", label: "关闭其他", onClick: () => closeOtherTabs(activeTab) },
              { key: "closeAll", label: "全部关闭", onClick: () => { closeAllTabs(); navigate("/pages/blank", { replace: true }); } },
            ],
          }} trigger={["click"]}>
            <Button size="small" type="text">关闭 ▼</Button>
          </Dropdown>
        )}
      </div>
    </div>
  );
}
